export default __webpack_public_path__ + "static/media/Times-New-Roman-bold.336764e1.ttf";